import { StickyDIPSlice } from "./types";

export const initialState: StickyDIPSlice = {
	data: undefined,
	stickyDIPsDisplayed: {},
	claimRewardProcess: {
		claiming: false
	}
};
